import axios from '../../plugins/axios';
import { Message } from 'element-ui';

export const brands_module = {
    state: ()=>({
        pending: false,
        loadingMore: false,
        data: {
            current_page: 1,
            data: [],
            last_page: null,
            searchedKeyword:'',
            filter:{
                status:[],
                indexed:[],
            },
            allFilters:[],
        },
        message: null,
        success: null,
        error: null
    }),
    mutations: {
        fetch_brands_request(state,loadingType){

            if(loadingType == 'new'){

                state.pending = true;

            }else if(loadingType == 'more'){

                state.loadingMore = true;

            }

        },
        fetch_brands_success(state, payload){

            if(payload.loadData === 'new'){

                state.data.data = payload.brands.data;

            }else if(payload.loadData === 'more'){

                state.data.data.push(...payload.brands.data);

            }

            state.data.current_page = payload.brands.current_page;
            state.data.last_page = payload.brands.last_page;
            state.pending = false;
            state.loadingMore = false;
            state.success = true;
            state.error = null;
            state.message = payload.message;

        },
        fetch_brands_failure(state, payload){

            state.data.data = [];
            state.pending = false;
            state.loadingMore = false;
            state.success = false;
            state.error = payload.error;
            state.message = payload.message;

        },
        add_brands_list(state,payload){

            state.data.data.unshift(payload);

        },
        update_brands_list(state,payload){

            let brandIndex = state.data.data.findIndex((listedbrand) => listedbrand.id == payload.brand.id);

            if(brandIndex != -1){

                state.data.data[brandIndex] = payload.brand

            }

        },
        update_brands_status(state,payload){

            state.data.data[payload.index].isActive = payload.updatedCategory.isActive

        },
        delete_brands_list(state,payload){

            state.data.data.splice(payload,1);

        },
        brands_bulk_action(state,payload){
            
            if(payload.action == 'delete'){

                state.data.data = state.data.data.filter((brand)=>{

                    if(!payload.listIds.includes(brand.id)){
                        
                        return brand

                    }

                });

            }else if(payload.action == 'statusChange'){

                state.data.data.forEach((brand) =>{

                    if(payload.listIds.includes(brand.id)){

                        brand.isActive = payload.status

                    }

                });

            }else if(payload.action == 'isIndexed'){

                state.data.data.forEach((brand) =>{

                    if(payload.listIds.includes(brand.id)){

                        brand.isIndexed = payload.indexed

                    }

                });

            }
            
        },
        update_searched_keyword(state,payload){

            state.data.searchedKeyword = payload.keyword

        },
        remove_searched_keyword(state){

            state.data.allFilters = []

            state.data.searchedKeyword = ''
            
        },
        update_brand_filters(state,payload){

            state.data.filter.status = payload.status
            state.data.filter.indexed = payload.indexed

        },
        update_brand_all_filters(state,payload){

            state.data.allFilters = payload

        },
        remove_brand_filters(state){

            state.data.filter.status = []
            state.data.filter.indexed = []

        },
        CLEAR_MODULE(state){

            state.pending = false
            state.loadingMore = false;
            state.message = null
            state.success = null
            state.error = null

            state.data.current_page = 1
            state.data.data = []
            state.data.last_page = null,
            state.data.searchedKeyword = ''
            state.data.filter = {
                status:[],
                indexed:[],
            }
            state.data.allFilters = []

        }
    },
    actions:{
        async fetchBrandsRequest({commit},{size, page, loadData}){

            commit('fetch_brands_request',loadData);

            const searchedKeyword = this.state.brands_module.data.searchedKeyword;
            let status = this.state.brands_module.data.filter.status[0];
            let indexed = this.state.brands_module.data.filter.indexed[0];

            try{
                let res = await axios.get('/brand/all',{
                    params:{
                        search: searchedKeyword.length > 0 ? searchedKeyword : null,
                        offset: size,
                        page: page,
                        active: status ? status == 'active' ? 1 : 0 : null,
                        indexed: indexed ? indexed == 'indexed' ? 1 : 0 : null,
                    }
                });
                if(res.data.status_code == '1390'){

                    res.data.loadData = loadData;

                    commit('fetch_brands_success', res.data);

                }
            }catch(ex){

                Message({
                    type: 'error',
                    showClose: true,
                    message: ex.response ? ex.response.data.message : ex.message,
                });

                commit('fetch_brands_failure', {error: ex, message: ex});
                
            }
            
        }
    },
    getters: {
        brands(state){

            return state.data.data;

        },
        keyword(state){

            return state.data.searchedKeyword;

        },
        isPending(state){

            return state.pending;

        },
        isLoadingMore(state){

            return state.loadingMore;

        },
        filters(state){

            return state.data.filter;

        },
        allFilters(state){

            return state.data.allFilters;

        },
        currentPage(state){

            return state.data.current_page;

        },
        lastPage(state){

            return state.data.last_page;

        },
        message(state){

            return state.message;
            
        },
        error:(state)=>state.error
    }
}